/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { QueryDto } from '../../models/query-dto';

export interface QueriesGet$Plain$Params {
  search?: string;
  includeDescription?: boolean;
}

export function queriesGet$Plain(http: HttpClient, rootUrl: string, params?: QueriesGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<QueryDto>>> {
  const rb = new RequestBuilder(rootUrl, queriesGet$Plain.PATH, 'get');
  if (params) {
    rb.query('search', params.search, {});
    rb.query('includeDescription', params.includeDescription, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<QueryDto>>;
    })
  );
}

queriesGet$Plain.PATH = '/queries';
